/**
 * Query Key factory for all appointment queries.
 *
 * @module Appointment
 */

import { Pagination } from "@customTypes/index";


export const appointmentQKeys = {
  all: () => ["appointments"] as const,

  allWithFilters: (filters?: {
    category?: string;
    status?: string;
    search?: string;
    sortBy?: string;
    filterBy?: string;
    pagination?: Partial<Pagination>;
    isQueued?: boolean;
  }) => [...appointmentQKeys.all(), { ...filters }] as const,

  detail: (id: string) => [...appointmentQKeys.all(), id] as const,

  slots: () => ["appointmentSlots"] as const,

  slotsWithFilters: (filters: {
    doctorAssigned?: string;
    withDoctorAssigned?: boolean;
    pagination?: Partial<Pagination>;
    startDate?: string;
    endDate?: string;
    booked?: boolean;
    managementView?: boolean;
  }) => [...appointmentQKeys.slots(), { ...filters }] as const,

  followUpForConsultations: () =>
    [...appointmentQKeys.all(), "followUp"] as const,

  followUpForConsultation: (consultationId: string) =>
    [...appointmentQKeys.followUpForConsultations(), consultationId] as const,

  notifications: (appointmentId: string) => [...appointmentQKeys.all(), "notifications", appointmentId] as const,

  calendarEvents: (appointmentId: string) => [...appointmentQKeys.all(), "calendarEvents", appointmentId] as const,
};
